import { AuthenticationError, BadRequestError, ConnectionError, ForbiddenError, NotFoundError, PayloadTooLargeError, TooManyRequestsError, UnknownError } from "./errors.js";
// src/lib/errors/errorTitle.ts
function errorTitle(error) {
	if (error instanceof BadRequestError) return "Invalid request";
	else if (error instanceof AuthenticationError) return "Login failed";
	else if (error instanceof ConnectionError) return "Network issue";
	else if (error instanceof ForbiddenError) return "Access denied";
	else if (error instanceof NotFoundError) return "Not found";
	else if (error instanceof PayloadTooLargeError) return "Request too large";
	else if (error instanceof TooManyRequestsError) return "Too many requests";
	else if (error instanceof UnknownError) return "Hmmm...";
	return null;
}
export { errorTitle as default };

//# sourceMappingURL=errorTitle.js.map